// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenu_wrapper__AVrlE","button":"MobileMenu_button__vpHfV","left":"MobileMenu_left__H6-Cp","right":"MobileMenu_right__pADdS","title":"MobileMenu_title__SDPht"};